import { lazy, Suspense, type ComponentType, type ReactNode } from "react";

type DynamicOptions = {
  loading?: ComponentType;
  ssr?: boolean;
};

export default function dynamic<Props extends object>(
  loader: () => Promise<ComponentType<Props> | { default: ComponentType<Props> }>,
  options: DynamicOptions = {},
) {
  const LazyComponent = lazy(async () => {
    const loaded = await loader();
    return typeof loaded === "object" && loaded && "default" in loaded
      ? loaded as { default: ComponentType<Props> }
      : { default: loaded as ComponentType<Props> };
  });
  const Loading = options.loading;
  function DynamicComponent(props: Props): ReactNode {
    return <Suspense fallback={Loading ? <Loading /> : null}><LazyComponent {...props} /></Suspense>;
  }
  DynamicComponent.displayName = "StaticDynamicComponent";
  return DynamicComponent;
}
